export const id = {
  "n1": "Halaman beranda",
  "n2": "Memesan",
  "n3": "transaksi",
  "n4": "tim",
  "n5": "milikku",
  "t1": "ada yang tidak beres",
  "t2": "Berhasil disalin",
  "t3": "Silakan isi informasi dengan lengkap",
  "t4": "Memuat...",
  "t5": "Masuk berhasil",
  "t6": "Skor harus lebih besar dari 3 untuk dikirimkan",
  "t7": "Pengiriman berhasil",
  "t8": "Saldo tidak mencukupi, tidak dapat menerima",
  "t9": "Pengiriman gagal",
  "t10": "Silakan ikat alamat penarikan terlebih dahulu",
  "t11": "Alamat telah terikat, silakan hubungi layanan pelanggan untuk memodifikasinya.",
  "t12": "Modifikasi berhasil",
  "t13": "Modifikasi gagal",
  "t14": "Silakan hubungi layanan pelanggan untuk mengubah kata sandi Anda",
  "t15": "Kesalahan format kata sandi",
  "t16": "Penarikan berhasil",
  "t17": "Jumlah maksimum yang dapat ditarik",
  "t18": "Penarikan minimal",
  "t19": "Dua kata sandi tidak konsisten",
  "t20": "Kiat",
  "t21": "Tidak dapat melompat saat ini",
  "t22": "Kesalahan format kata sandi",
  "t23": "Pendaftaran berhasil",
  "t24": "Silakan masukkan kode area",
  "t25": "Tidak lebih",
  "l1": "Bahasa",
  "l2": "Silakan masukkan nomor rekening",
  "l3": "Silakan masukkan kata sandi",
  "l4": "ingat",
  "l5": "Masuk",
  "l6": "Pergi untuk mendaftar",
  "l7": "Tidak ada akun",
  "l8": "Nomor ponsel",
  "l9": "Nama panggilan",
  "l10": "Kata sandi",
  "l11": "Konfirmasikan kata sandi",
  "l12": "Kode undangan",
  "l13": "Daftar",
  "l14": "Sudah punya akun",
  "l15": "Pergi untuk masuk",
  "l16": "Silakan masukkan kata sandi 6-16 digit",
  "bz1": "bantuan",
  "bz2": "Pertanyaan Umum",
  "bz3": "aturan perdagangan",
  "bz4": "Cara menarik uang",
  "bz5": "Cara mengisi ulang",
  "bz6": "1. Apa itu RoBoT Ulasan Amazon?",
  "bz7": "Amazon Review RoBoT adalah perusahaan promosi pemasaran yang membantu pedagang toko online Amazon Review RoBoT di seluruh dunia mendapatkan lebih banyak penjualan pesanan dan meningkatkan data penelusuran toko online Amazon Review RoBoT. Kami berkomitmen untuk membangun model pemasaran dan promosi tiga pihak yang menguntungkan antara Amazon Review RoBoT, pedagang, dan konsumen. Dikombinasikan dengan teknologi blockchain P2P terbaru, konsumen dan pedagang terhubung dengan cepat melalui USDT (TRC20, ERC20). Pengguna terdaftar bisa mendapatkan komisi atas pesanan, sementara pedagang dapat meningkatkan data penjualan tokonya. Ini adalah model keuntungan terbaru dalam model blockchain Internet!",
  "bz8": "2. Bagaimana cara kerja Amazon Review RoBoT?",
  "bz9": "Umpan balik harian dari Amazon Review RoBoT menunjukkan bahwa produk yang memerlukan perbaikan dijual di Amazon Review RoBoT. Pengguna hanya perlu mengklik pesanan dengan mudah, dan sistem secara otomatis membuat langganan pesanan. Pengguna membayar jumlah pesanan melalui blockchain USDT dan menerima komisi harian.",
  "bz10": "3.Mengapa harga mata uang yang sama berbeda dalam dua transaksi?",
  "bz11": "Perbedaan harga disebabkan oleh semua faktor yang tidak mendukung peredaran bebas mata uang, termasuk kecepatan transfer mata uang, kondisi jaringan, pembatasan akses mata uang, pengakuan mata uang oleh orang-orang di berbagai wilayah, dan bahkan jenis pasangan perdagangan yang disediakan oleh bursa, transaksi, dll. Oleh karena itu, mata uang yang sama mungkin memiliki perbedaan harga dalam transaksi yang berbeda.",
  "bz12": "4. Keuntungan investasi?",
  "bz13": "Semakin tinggi harga barang yang Anda dapatkan, semakin tinggi pula keuntungan yang Anda peroleh atas pesanan tersebut. Pada saat yang sama, Amazon Review RoBoT secara acak mendistribusikan pesanan komisi dalam jumlah besar.",
  "bz14": "Setiap hari, sistem secara otomatis menghasilkan dan mendistribusikan 60 pesanan produk kepada pengguna. Pengguna menyelesaikan pembayaran untuk setiap pesanan melalui USDT dan menerima komisi 0,6%. Pesanan komisi besar diberikan secara acak.",
  "bz15": "USDT dapat ditarik setelah 60 pesanan. (Jika 60 pesanan tidak diselesaikan, sistem akan otomatis berhenti hingga sisa pesanan hari itu)",
  "bz16": "Setiap akun hanya dapat terikat pada satu akun USDT. Jika terjadi kesalahan, silakan hubungi layanan pelanggan.",
  "bz17": "Setelah menyelesaikan pengiriman pesanan harian, Anda dapat menarik uang secara normal. Uang akan tiba dalam waktu 24 jam setelah penarikan dimulai, dan tidak ada batasan penarikan.",
  "bz18": "Sebelum mengisi ulang, harap ikat alamat penarikan Anda (mendukung TRC-20) alamat USDT. Anda dapat mengklik isi ulang di APLIKASI atau halaman web dan pilih blockchain (TRC-20) yang Anda gunakan untuk mengisi ulang.",
  "bz19": "Dilarang melakukan saling isi ulang, transfer bank, transfer bursa, dan lain-lain antar rekening terkait. Perilaku ini diduga merupakan perampasan pesanan yang berbahaya. Jika perilaku seperti itu ditemukan, akun tersebut akan diblokir.",
  "ty1": "Oke",
  "ty2": "Batalkan",
  "ty3": "Kirim",
  "ty4": "Alamat TRC20",
  "ty5": "Alamat ERC20",
  "s1": "Pendapatan kumulatif",
  "s2": "layanan",
  "s3": "Tentang kami",
  "s4": "bantuan",
  "s5": "Mitra",
  "s6": "layanan saya",
  "d1": "Belum selesai",
  "d2": "Selesai",
  "d3": "Belum ada datanya",
  "d4": "Nomor pesanan",
  "d5": "jam perdagangan",
  "d6": "Jumlah",
  "d7": "Jumlah tugas saat ini",
  "d8": "pengembalian yang diharapkan",
  "d9": "Masih perlu",
  "d10": "Peringkat",
  "j1": "Saldo akun",
  "j2": "Pengenalan perdagangan",
  "j3": "Amazon Review RoBoT menggunakan umpan balik dari Amazon Review RoBoT setiap hari untuk menampilkan produk yang dijual oleh Amazon Review RoBoT yang memerlukan perbaikan. Pengguna hanya perlu mengklik pesanan dan sistem akan otomatis menghasilkan tanda tangan pesanan. Pengguna membayar jumlah pesanan melalui blockchain USDT dan dapat menerima komisi lebih dari 0,6% setiap kali, dan sistem secara acak mendistribusikan pesanan hadiah dalam jumlah besar.",
  "j4": "Mulai mencocokkan",
  "j5": "Penghasilan hari ini",
  "j6": "Selesai",
  "j7": "Jumlah total tugas",
  "td1": "keseimbangan",
  "td2": "Komisi",
  "td3": "menerima",
  "td4": "jumlah total orang",
  "td5": "Pengguna",
  "td6": "Berkontribusi",
  "td7": "Kuantitas",
  "td8": "Status",
  "g1": "Tarik uang tunai",
  "g2": "Isi ulang",
  "g3": "Undang teman",
  "g4": "Undang sekarang",
  "g5": "Untuk setiap keuntungan yang diperoleh teman Anda setelah mereka mendaftar, Anda akan menerima komisi yang sesuai.",
  "g6": "informasi pribadi",
  "g7": "Detail dana",
  "g8": "Catatan isi ulang",
  "g9": "Catatan penarikan",
  "g10": "Bahasa",
  "g11": "Keluar",
  "g12": "Apakah Anda yakin ingin logout?",
  "yh1": "Informasi pengguna",
  "yh2": "Memodifikasi",
  "yh3": "pengaturan",
  "yh4": "telepon",
  "yh6": "Kata sandi asli",
  "yh7": "kata sandi baru",
  "mx1": "Pengumpulan komisi",
  "mx2": "pendapatan",
  "mx3": "Penarikan ditolak",
  "mx4": "waktu",
  "mx5": "Isi ulang berhasil",
  "mx6": "Ditolak",
  "mx7": "Tertunda",
  "mx8": "Alamat penarikan",
  "mx9": "saldo yang tersedia",
  "mx10": "Kedatangan sebenarnya",
  "mx11": "Silakan masukkan jumlah penarikan",
  "cz2": "Salin",
  "cz3": "Pemilihan mata uang fiat",
  "cz4": "membayar",
  "cz5": "Alamat setoran hanya mendukung TRC20-USDT, dan jumlah setoran minimum adalah 20USDT.",
  "cz6": "Alamat setoran hanya mendukung ERC20, dan jumlah setoran minimum adalah 20USDT.",
  "cz1": "Alamat setoran hanya mendukung ERC20, dan jumlah setoran minimum adalah 20USDT.",
  "cz10": "Alamat deposit hanya mendukung BTC",
  "qy1": "kode area",
  "yq1": "Undang teman",
  "yq2": "Kode undangan",
  "yq3": "Undang teman dan nikmati manfaat besar",
  "yq4": "Pergi dan undang",
  "new1": "Metode pembayaran",
  "zf1": "Metode isi ulang",
  "zf2": "Silakan pilih metode isi ulang",
  "zf3": "mata uang perdagangan",
  "zf4": "jaringan perdagangan",
  "zf5": "Pergi ke perdagangan",
  "zf6": "Berhasil disalin",
  "zf7": "mata uang perdagangan",
  "zf8": "Silakan gunakan",
  "zf9": "Transfer uang ke alamat di bawah ini untuk menyelesaikan isi ulang.",
  "zf10": "Mata uang transaksi",
  "zf11": "Salin",
  "zf12": "Silakan periksa alamatnya dengan cermat. Jika Anda salah mentransfernya, Anda tidak akan dapat mengambilnya kembali.",
  "zf13": "Waktu kedatangan",
  "zf14": "Sekitar 1 ~ 5 menit",
  "zf15": "Jumlah isi ulang minimum",
  "a1": "Pusat Pemasaran Toko",
  "a2": "Pusat pemasaran toko Robot Pasar Amazon adalah bagian baru yang dirancang untuk membantu pedagang dengan cepat meningkatkan tingkat penjualan dan pujian produk mereka dalam waktu singkat, sehingga meningkatkan bobot produk dan semakin meningkatkan eksposur mereka; pengguna membantu pedagang dengan menyelesaikan berbagai tugas dan menerima hadiah yang sesuai, sehingga mencapai situasi win-win bagi kedua belah pihak.",
  "a3": "Saat ini, sistem ini memiliki 30 juta pengguna dan 5 juta pedagang, dan jumlah produk yang dipromosikan di platform setiap hari mencapai 70 juta; beberapa produk pedagang telah meningkatkan penjualan toko sebesar 60% dengan menghubungkan ke sistem pusat pemasaran; dan pengguna platform sistem pusat pemasaran hanya perlu mengklik pesanan, dan sistem pusat pemasaran akan secara otomatis menghasilkan tanda tangan pesanan. Setelah pengguna membayar jumlah pesanan di muka, transaksi virtual selesai, dan dana segera dikembalikan ke akun pengguna. Komisi tambahan lebih dari 0,6% dapat diperoleh setiap kali. Sistem juga akan secara acak mengalokasikan pesanan hadiah dalam jumlah besar untuk meningkatkan komisi pengguna.",
  "a4": "Robot Pasar Amazon sangat mementingkan kebutuhan pengguna dan pedagang, dan terus mengoptimalkan dan meningkatkan sistem pusat pemasaran.",
  "kf1": "Layanan Online",
  "kf2": "Layanan Penarikan Manual",
  "kf3": "Klik di sini untuk menghubungi layanan penarikan manual",
  "kf4": "Layanan Isi Ulang Manual",
  "kf5": "Klik di sini untuk menghubungi layanan isi ulang manual",
  "zf16": "Untuk transaksi kartu bank, silakan hubungi layanan pelanggan",
  "zf17": "Hubungi layanan pelanggan",
}
